import type { RouteObject } from "react-router";
import { LocationList } from "./LocationList";

export const locationRoute: RouteObject = {
  path: "location",
  element: <LocationList />,
};
